var TopicCacheEntry = require('routing/topic-cache-entry');

module.exports = function SingleValueEntry(details, streams) {
    TopicCacheEntry.call(this, details, streams);

    var value;

    this.handleValue = function(received, registry, errorHandler) {
        this.notifyValue(received, value, received, registry);
        value = received;
    };

    this.handleDelta = function(received, registry, errorHandler) {
        this.notifyDelta(received, null, value, received, registry);
        value = received;
    };

    this.notifyValueToNewStream = function(path, details, stream) {
        if (value) {
            stream.onValue(path, details, value, null, value);
        }
    };
};


//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/routing/topic-cache-single-value-entry.js
// module id = 1038
// module chunks = 0